import { identifyAnalyticsUser, trackEvent } from "./firebase-analytics";

type SignupMethod = "email" | "google";
const COHORT_KEY = "impret_signup_cohort:";
const FIRST_VALUE_KEY = "impret_first_value:";
export const GOOGLE_SIGNUP_KEY = "impret_google_signup_pending";

// Only fixed event labels and opaque account IDs, never email, OTP, passwords,
// prompts, URLs, provider errors or client content.
export function completeSignup(userId: string, method: SignupMethod) {
  identifyAnalyticsUser(userId);
  trackEvent("signup_completed", { method, completion: "authenticated_signup_flow" });
  try {
    if (!localStorage.getItem(COHORT_KEY + userId)) {
      localStorage.setItem(COHORT_KEY + userId, String(Date.now()));
    }
  } catch {
    // Storage restrictions must not interrupt authentication.
  }
}

export function trackFirstValue(userId: string, draftCount: number) {
  if (!userId || draftCount < 1) return;
  try {
    const startedAt = localStorage.getItem(COHORT_KEY + userId);
    if (!startedAt || localStorage.getItem(FIRST_VALUE_KEY + userId)) return;
    // Browser-local deduplication for the post-release signup-flow cohort.
    localStorage.setItem(FIRST_VALUE_KEY + userId, "1");
    trackEvent("first_value_reached", {
      milestone: "first_successful_drafts",
      draft_count: draftCount,
      seconds_since_signup: Math.max(0, Math.round((Date.now() - Number(startedAt)) / 1000)),
    });
  } catch {
    // No storage means no deduplicated first-value event; regular generation
    // events still work. Do not risk repeating a conversion on every draft.
  }
}
